import { NavLink } from "react-router-dom";
import { useFetchMenuQuery } from "../redux/rtk/MenuRTK";

export default function MobileNavNested() {


    const { data, error, isLoading } = useFetchMenuQuery();

    console.log('menu data are: ', data, error, isLoading);

    console.log('data.data is: ', data);

    if (isLoading) {
        return <MobileNavNestedLoading />
    }

    if (!isLoading) {

        return <ul className="nav d-block nested-menu list mt-2 px-0">
            {data.map((item) => (
                <_RenderMenu key={item.id} item={item} />
            ))}
        </ul>
    }

}


function _RenderMenu({ item }) {
    const hasChildren = item.children && item.children.length > 0;

    return (
        <li className={`nav-item ${hasChildren ? "dropdown-hover" : ""}`}>
            {/* <a className="nav-link" href={item.link}>
                {item.label}
                {hasChildren && <span className="arrow">›</span>}
            </a> */}

            <GetLink hasChildren={hasChildren} row={item} />

            {hasChildren && (
                <ul className="dropdown-menu">
                    {item.children.map((child) => (
                        <_RenderMenu key={child.id} item={child} />
                    ))}
                </ul>
            )}
        </li>
    );
}


function MobileNavNestedLoading() {
    // if (row.open_in_new_tab == 1 || row.link.includes("https://")) {

    const arr = [1, 2, 3, 4, 5];

    return arr.map((item) => {
        return (<span key={item.id} className={"nav-link text-decoration-none header-link-loading-state"}>
            Loading
        </span>)
    })

}


function GetLink({ linkClasses, hasChildren, row }) {
    if (row.open_in_new_tab == 1 || row.link.includes("https://")) {
        return (
            <a href={row.link} className={"nav-link text-decoration-none"}>
                {row.label}

                {hasChildren && <span className="arrow">›</span>}
            </a>
        );
    } else {
        return (
            <NavLink
                to={row.link}
                className={({ isActive }) =>
                    isActive ? `active ${linkClasses} nav-link text-decoration-none` : `nav-link text-decoration-none ${linkClasses}`
                }
            >
                {row.label} {hasChildren && <span className="arrow">›</span>}
            </NavLink>
        );
    }
}